import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosInstance';
import { FaSearch, FaPen, FaPlus } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import * as general from '../libs/general';
import AdLayout from '../components/AdLayout';
import DataTable from '../components/ui/DataTable';
import CategoryEditor from '../components/products/CategoryEditor';
import { fetchCategoryMenuPermissions } from "../libs/customerCreatePermission";

const Categories = () => {
  const [categoryEditorData, setCategoryEditorData] = useState(null);
  const [pageData, setPageData] = useState({ content: [] });
  const [message, setMessage] = useState("");
  const hasRun = useRef(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [categoryFeaturePerm, setCategoryFeaturePerm] = useState({
    loaded: false,
    canView: false,
    canCreate: false,
    canEdit: false,
  });
  const [categoryAccess, setCategoryAccess] = useState("allowed");
  const navigate = useNavigate();


  useEffect(() => {
    searchCategories();
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchCategoryMenuPermissions(axiosInstance);
      if (cancelled) return;
      setCategoryFeaturePerm({
        loaded: true,
        canView: Boolean(p.canView),
        canCreate: Boolean(p.canCreate),
        canEdit: Boolean(p.canEdit),
      });
      if (!(p.canView || p.canEdit)) {
        setCategoryAccess("denied");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);


  const getFirstNode = (current, pre) => {
    if (!pre) return "first-node";
    if (current.level !== pre.level) return "first-node";
    return "normal-node";
  };
  const handleSearchChange = (e) => {
    var searchValue = e.target.value;
    searchCategories({ page: 0, keyword: searchValue });
    setSearchQuery(e.target.value);
  };

  const searchCategories = async (filter) => {
    if (window.calling) return;
    window.calling = true;
    setIsLoading(true);
    setMessage('');
    var params = general.getSession('search_products');

    var formData = general.getFormData('.form_filter');
    Object.assign(params, formData);

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('search_products');
      Object.assign(params, oldParams);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('search_products', params);
    window.initializeFilterValue(params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};
    try {
      response = await axiosInstance.get('/api/products/searchCategories', { params: filteredParams });
      setPageData(response.data);
    } catch (error) {
      if (error.status === 401) setTimeout(navigate, 2000, '/dang-nhap');
      setPageData({ content: [] });
      var message = error.response ? error.response.data.message : error.message;
      setMessage(message);
      console.error(error);
    }
    window.calling = false;
    setIsLoading(false);
  };
  const openCategoryEditor = (id) => {
    if (id === 0 && !categoryFeaturePerm.canCreate) return;
    if (id > 0 && !categoryFeaturePerm.canEdit) return;
    setCategoryEditorData({ id: id });
  };

  if (categoryAccess === "denied") {
    return (
      <div>
        <AdLayout>
          <div className="container py-4">
            <div className="alert alert-warning mb-0">Truy cập không được phép.</div>
          </div>
        </AdLayout>
      </div>
    );
  }

  return (
    <div>
      <AdLayout>
        <div className="table-responsive web-table customer-management-page">
          <div className="container-fluid">
            <div className="row bg-dark align-items-center">
              <div className="col-12 col-md-7 order-3 order-md-1 py-1 d-flex align-items-center">
                <div className="flex-start gap-2">
                  {categoryFeaturePerm.canCreate && (
                    <button type="button" className="btn btn-success btn-sm" onClick={() => openCategoryEditor(0)} title="Danh mục mới">
                      <FaPlus /> Thêm mới
                    </button>
                  )}
                </div>
              </div>
              <div className="col-7 col-md-2 py-1 fw-bold text-white text-uppercase d-flex align-items-center justify-content-star order-1 order-md-2">
                Quản lý danh mục
              </div>
              <div className="col-5 col-md-3 py-1 order-2 order-md-3 d-flex justify-content-end align-items-center">
                <form id="form_filter" className="form_filter mb-0 w-auto">
                  <div className="input-group search-block flex-nowrap">
                    <input name="keyword"
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Tìm kiếm..."
                      value={searchQuery}
                      onChange={(e) => handleSearchChange(e)}  // Ensure `e` is passed to the function
                    />
                    <button className="btn btn-light btn-sm" type="button" title="Tìm kiếm..." onClick={(event) => searchCategories({ page: 0 })}>
                      <FaSearch />
                    </button>
                  </div>
                </form>
              </div>
            </div>


          </div>

          <section className="pt-1">
            <DataTable maxHeight="calc(100vh - 160px)" className="table-normal" data-loading={isLoading}>
              <table className="table table-striped table-bordered border-normal">
                <thead className="table-primary">
                  <tr>
                    <th width="64px" className="sticky text-center">STT</th>
                    <th className="text-center"><span>Tên danh mục</span></th>
                    <th className="text-center" style={{ width: '170px' }}><span>Số lượng sản phẩm</span></th>
                    <th className="text-center" style={{ width: '32%' }}><span>Mô tả</span></th>
                    <th className=" d-none"><span>ParentId</span></th>
                    <th width="110px" className="text-center">Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  {pageData.tree && (() => {
                    let parentSeq = 0;
                    return pageData.tree.map((item, index) => {
                    const isParent = Number(item.level) === 1;
                    const stt = isParent ? ++parentSeq : '';
                    return (
                    <tr key={item.id}>
                      <td className="sticky text-center">{stt}</td>
                      <td className={`tree-node ${getFirstNode(item, pageData.tree[index - 1])}`}>
                        {categoryFeaturePerm.canEdit ? (
                          <span
                            role="button"
                            tabIndex={0}
                            data-level={item.level}
                            style={{ color: "#485766" }}
                            onClick={() => openCategoryEditor(item.id)}
                            onKeyDown={(e) => e.key === "Enter" && openCategoryEditor(item.id)}
                            title="Xem chi tiết danh mục"
                          >
                            {item.name}
                          </span>
                        ) : (
                          <span data-level={item.level}>{item.name}</span>
                        )}
                      </td>

                    <td className="text-center">{item.productCount ? item.productCount.toLocaleString("vi-VN") : "0"}</td>

                    <td className="text-start mw-200">{item.description}</td>
                    <td className="text-start mw-200 d-none">{item.parentId}</td>
                    
                      <td className="text-center align-middle">
                        <div>
                          {categoryFeaturePerm.canEdit && (
                            <FaPen className="text-primary me-2" role="button" tabIndex={0} onClick={() => openCategoryEditor(item.id)} onKeyDown={(e) => e.key === "Enter" && openCategoryEditor(item.id)} size={15} title="Cập nhật" />
                          )}
                        </div>
                      </td>
                    </tr>
                    );
                    });
                  })()}
                </tbody>
                  <tbody>
                  {message === '' && pageData.tree && pageData.tree.length === 0 && (
                    <tr>
                      <td colSpan="5" className="text-center">Không tìm thấy dữ liệu</td>
                    </tr>
                  )}
                  {message !== '' && (
                    <tr>
                      <td colSpan="5" className="text-center">{message}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </DataTable>
          </section>
          <div className="mt-2 d-flex justify-content-end align-items-center">

          </div>
        </div>

        {categoryEditorData && (
          <CategoryEditor data={categoryEditorData} handleSearch={searchCategories} />
        )}

      </AdLayout>
    </div>
  );
}
export default Categories;